var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SdsMobileHeader',{attrs:{"hasProfileIcon":!!_vm.user},scopedSlots:_vm._u([{key:"middle",fn:function(){return [_c('SdsGlobalHeaderLogo')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }